<script>
  import Ring from "../ring/Ring.svelte";
  import { getContext } from "svelte";

  const { close } = getContext("simple-modal");

  const TxStatus = {
    AwaitingSignature: "AwaitingSignature",
    AwaitingConfirmation: "AwaitingConfirmation",
    Error: "Error",
  };

  export let sale;
  export let isStartSale = false;

  let txStatus = TxStatus.AwaitingSignature,
    errorMsg;

  const startSale = async () => {
    try {
      const tx = await sale.start();
      txStatus = TxStatus.AwaitingConfirmation;
      await tx.wait();
      close();
    } catch (e) {
      errorMsg = e.message;
      if (errorMsg.length > 500) errorMsg = "Something went wrong";
      txStatus = TxStatus.Error;
    }
  };

  const endSale = async () => {
    try {
      const tx = await sale.end();
      txStatus = TxStatus.AwaitingConfirmation;
      await tx.wait();
      close();
    } catch (e) {
      errorMsg = e.message;
      if (errorMsg.length > 500) errorMsg = "Something went wrong";
      txStatus = TxStatus.Error;
    }
  };

  if (isStartSale) startSale();
  else endSale();
</script>

{#if txStatus === TxStatus.AwaitingSignature}
  <div class="flex items-center">
    <Ring color="#fff" />
    <span class="text-lg">Awaiting signature...</span>
  </div>
{/if}

{#if txStatus === TxStatus.AwaitingConfirmation}
  <div class="flex items-center">
    <Ring color="#fff" />
    <span class="text-lg">Transaction confirming...</span>
  </div>
{/if}

{#if txStatus === TxStatus.Error}
  <div class="flex column-direction buy-modal items-center gap-y-5 p-6">
    <span class="modal-title">Something went wrong.</span>
    <span class="text-lg text-red-400">{errorMsg}</span>
  </div>
{/if}

<style>
  .approved-modal span.title {
    font-size: 18px;
    line-height: 22px;
    color: #fff;
    margin: 0 0 20px;
  }
  span.text-lg {
    color: #fff;
  }
  a.text-blue-400 {
    margin: 0 0 20px;
  }
</style>
